module.exports = __webpack_public_path__ + "img/icon_map_38_on_010.9e1909cd.png";